import { gql } from "apollo-boost"

export const deletedContracts = gql`
  mutation deletedContracts($id:ID!) {
    DeletedContracts(id: $id)
  }
`